import Correlaction from '../Correlaction';
import WmdsItem from '../Wmds';
import WebcastleItem from '../Webcastle';
import WsfinderItem from '../Wsfinder';
import Wfdetector from '../Wfdetector'
import  codes  from '@/f1/codes';
import _ from 'lodash';
import { api, auth, signalr, } from '@/f1/service';
import Language from './language';
import wsf_agent_cmd from '../../WSFinder/agent/service'
import wc_agent_cmd from '../../WebCastle/modules/service'

const _i18n_data = {
  username: {
    EN : () => `Username required.`,
    KO : () => `아이디를 입력하세요.`,
  },
  password: {
    EN : () => `Password required.`,
    KO : () => `비밀번호를 입력하세요.`,
  }
};
export default {
  components : {
    Language,
    'correlaction' : Correlaction,
    'wsfinder-item' : WsfinderItem,
    'wmds-item' : WmdsItem,
    'webcastle-item' : WebcastleItem,
    'wfdetect-item' : Wfdetector,
    codes
  },
  data: () => {
    return {
      wc_ping_list : [],
      wsf_ping_list : [],
      wc_pong_list : [],
      wsf_pong_list : [],
      signalr,
      UWSS_analysis : [],
      refresh : 10, // min
      hot : [],
      auth,
      WSF : '',
      WC : '',
      WMDS : '',
      WF : undefined,
      UWSS_status : 0,
      th : undefined,
      ping_th : undefined,
    }
  },
  computed: { i18n_data() { return _i18n_data; } }, // i18n 메세지 변환용.
  methods : {
    async ping(){
      try {
        if(this.ping_th) { clearTimeout(this.ping_th); }
        this.wsf_ping_list.forEach(x => wsf_agent_cmd.ws.Cmd("ping", x).then(rs => this.res(rs)))
        this.wc_ping_list.forEach(x => wc_agent_cmd.Cmd("ping", x).then(rs => this.res(rs)))

        this.ping_th = setTimeout(this.ping, 15 * 1000)
      } catch(e) { console.log('ping', e)}
    },
    async load() {
      var target = {
          target : 'dashboard', cmd : 'status',
          body: { and: [], or: [], sort: [],
        }
      }

      let WC = { body : [] }
      let WMDS = { body : [] }
      let WSF = { body : [] }

      try {
        WC = await api.webcastle.WebCastle(target);
        this.WC = WC.body.data.webcastle_status;
      } catch (e) {
        console.log('WC load failed', e)
        this.WC = { body : [] }
      }

      try {
        WSF = await api.wsfinder.WSFinder(target);
        this.WSF = WSF.body.data.wsf_status;
      } catch (e) {
        console.log('WSF load failed', e)
        this.WSF = { body : [] }
      }

      try {
        WMDS = await api.wmds.WMDS(target);
        this.WMDS = WMDS.body.data.wmds_status;
      } catch (e) {
        console.log('WMDS load failed', e)
        this.WMDS = { body : [] }
      }

      // WMDS.body.length ? console.log('WMDS', WMDS.body.wf_status) : ''
      // WSF.body.length ? console.log('WSF', WSF.body.wf_status) : ''

      this.WF = _.concat([], WMDS.body && WMDS.body.data  ? WMDS.body.data.wf_status : [], WSF.body && WSF.body.data ? WSF.body.data.wf_status : [])


      // let wsf_target_list = []
      let wc_target_list = []
      let wf_target_list = []

      // if(this.WSF) { this.WSF.forEach(c => wsf_target_list = _.concat(wsf_target_list, c.detect_list)); }
      if(this.WC) { this.WC.forEach(c => wc_target_list = _.concat(wc_target_list, c.detect_list)); }
      if(this.WF) { this.WF.forEach(c => wf_target_list = _.concat(wf_target_list, c.detect_list)); }

      // console.log(wf_target_list, 'WMDS.body.wf_status', wsf_target_list)

      this.now_status(_.compact(wc_target_list), _.compact(wf_target_list))

      this.stop_refresh()
      this.th = setTimeout(this.load, this.refresh * 60 * 1000);
    },
    now_status(list_from_wc = [], list_from_wf = []) {
      console.log('list_from_wc', list_from_wc.length, 'list_from_wf', list_from_wf.length)
      // 0,1,2
      // 0 : success
      // 1 : warning
      // 2 : danger
      this.UWSS_status = 0;
      let count = 0
      this.UWSS_analysis = []
      let sample_data = { domain : '', ip_addr : '', is_wc : false, is_wsf : false, is_wmds : false, is_wf : false, }

      // webcastle
      // 서버리티 레벨에서 4 이상의 탐지가 24 시간 안에 있을 경우, 레벨에 따른 가중치 계산 필요
      _.forEach(this.WC, r => {
        this.wc_ping_list.push(r.agent_id)
        // r.score += r.is_row ? 1 : 0
        count += r.is_row ? 1 : 0
        let index = _.findIndex(this.UWSS_analysis, x => (x.domain && x.domain == r.domain) || (x.ip_addr && x.ip_addr == r.ip_addr))

        if(index > -1) { this.UWSS_analysis[index] = Object.assign({}, this.UWSS_analysis[index], { is_wc : true, wc_agent_id : r.agent_id }) }
        else { this.UWSS_analysis.push(Object.assign({}, r, sample_data, { name : r.name, domain: r.domain, ip_addr: r.ip_addr, is_wc : true, wc_agent_id : r.agent_id })) }
      });

      // 이후 부분은 탐지가 되면 안되는 부분으로 webcastle 보다 가중치 필요
      // wmds
      _.forEach(this.WMDS, r => {
        // r.score += r.is_row > 0 ? 1 : 0
        count += r.is_row ? 1 : 0
        r.domain = r.fqdn ? r.fqdn : r.domain

        let index = _.findIndex(this.UWSS_analysis, x => (x.domain && x.domain == r.domain) || (x.name && x.name == r.name))
        if(index > -1) { this.UWSS_analysis[index].is_wmds = true }
        else { this.UWSS_analysis.push(Object.assign({}, r, sample_data, { name : r.name, domain: r.domain, ip_addr: r.ip_addr, is_wmds :true })) }
      });
      // if(!this.UWSS_status) { console.log("WMDS : good!, :D"); return; }

      // wsfinder
      _.forEach(this.WSF, r => {
        this.wsf_ping_list.push(r.agent_id)
        // r.score += r.is_row > 0 ? 1 : 0
        count += r.is_row ? 1 : 0
        let index = _.findIndex(this.UWSS_analysis, x => (x.name && x.name == r.name) || (x.ip_addr && x.ip_addr == r.ip_addr) || (x.ip_addr_private && x.ip_addr_private == r.ip_addr_private))

        if(index > -1) { this.UWSS_analysis[index] = Object.assign({}, this.UWSS_analysis[index], { is_wsf : true, wsf_agent_id : r.agent_id }) }
        else { this.UWSS_analysis.push(Object.assign({}, r, sample_data, { name : r.name, domain: r.domain, ip_addr: r.ip_addr, is_wsf : true, wsf_agent_id : r.agent_id })) }
      });
      // if(!this.UWSS_status) { console.log("WSF : good!, :D"); return; }

      // wf
      _.forEach(this.WF, r => {
        // r.score += r.detect > 0 ? 1 : 0
        count += r.detect > 0 ? 1 : 0
        r.domain = r.fqdn ? r.fqdn : r.domain
        let index = _.findIndex(this.UWSS_analysis, x => (x.domain && x.domain == r.domain) || (x.ip_addr && x.ip_addr == r.ip_addr))
        if(index > -1) { this.UWSS_analysis[index].is_wf = true }
        else { this.UWSS_analysis.push(Object.assign({}, r, sample_data, { name : r.nickname, domain: r.domain, ip_addr: r.ip_addr, is_wf : true })) }
      });
      // if(!this.UWSS_status) { console.log("WF : good!, :D"); return; }

      if(count > 0) {
        this.UWSS_status = 1
        if(count > 3) { this.UWSS_status = 2 }
      }
      this.auth.UWSS_status = this.UWSS_status;
      this.ping()

      this.hot = []
      let debug = location.hostname == 'localhost' ? true : false
      debug = false

      // 아래는 탐지된 것으로 보여주는 것
      // 도메인관련 검사
      try {
        // webcastle =>  wmds, wf
        _.forEach(list_from_wc, domain => {
          let wmds = _.filter(this.WMDS, m => {
            debug ? console.log('[+][domain] wmds <-> wc', domain, m.fqdn, domain == m.fqdn ? 'related attack' : '') : ''
            return domain.indexOf(m.fqdn) > -1
          })
          debug ? console.log('###############################################################') : ''
          let wf = _.filter(list_from_wf, f => {
            // 도메인일 경우만 매칭됨
            debug ? console.log('[+][domain] wf <-> wc ', domain, f, domain == f ? 'related attack' : '') : ''
            return domain && domain.indexOf(f) > -1
          })
          if(wmds.length > 0 || wf.length > 0) {
            let index = _.findIndex(this.hot, x => x.domain == domain)
            if(index > -1) {
              // if() {  this.hot[index].is_wmds = !this.hot[index].is_wmds && wmds.length > 0 }
              // if() {  this.hot[index].is_wf = !this.hot[index].is_wf && wf.length > 0 }
              if(!this.hot[index].is_wmds && wmds.length > 0) {

                this.hot[index].is_wmds = !this.hot[index].is_wmds && wmds.length > 0
                this.hot[index].is_wc = !this.hot[index].is_wc && wmds.length > 0 // 해당 도메인을 호스트로 요청한 경우
              }

              this.hot[index].is_wf = !this.hot[index].is_wf && wf.length > 0
            } else {
              this.hot.push(Object.assign({}, sample_data, { domain : domain, is_wf :(wf.length > 0), is_wmds : (wmds.length > 0), is_wc : true, is_wsf : false }))
            }
            console.log('[V] update wc -> wmds,wf', this.hot[index < 0 ? this.hot.length -1 : index].domain)
          }
        })
        debug = false

        debug ? console.log('###############################################################') : ''
        debug ? console.log(this.hot) : ''

        // wmds =>  wc, wf
        _.forEach(this.WMDS, m => {
          if(!m.is_row) { return debug ? console.log('wmds =>  wc, wf is safe', m) : '' }
          let wc = _.filter(list_from_wc, domain => {
            debug ? console.log('[+][domain] wf <-> wmds ', domain, m.fqdn, domain.indexOf(m.fqdn) > -1  ? 'related attack' : '') : ''
            return domain && domain.indexOf(m.fqdn) > -1
          })

          let wf = _.filter(list_from_wf, f => {
            debug ? console.log('[+][domain] wf <-> wmds ', f, f.indexOf(m.fqdn) > -1 ? 'related attack' : '') : ''
            return f.indexOf(m.fqdn) > -1
          })
          if(wc.length > 0 || wf.length > 0) {
            let index = _.findIndex(this.hot, x => x.domain.indexOf(m.fqdn) > -1)

            if(index > -1) {
        //       this.hot[index] = Object.assign({}, this.hot[index], { domain : m.fqdn, is_wf :(wf.length > 0), is_wc : (wc.length > 0) })
              if(this.hot[index].is_wc == false && wc.length > 0) {  this.hot[index].is_wc = true }
              if(this.hot[index].is_wf == false && wf.length > 0) {  this.hot[index].is_wf = true }
            } else {
              this.hot.push(Object.assign({}, sample_data, { domain : m.fqdn, is_wf :(wf.length > 0), is_wc : (wc.length > 0) }))
            }
            console.log('[V] update wmds -> wc, w', this.hot[index < 0 ? this.hot.length -1 : index].domain)
          }
        })

        debug ? console.log('###############################################################') : ''
        debug ? console.log(this.hot) : ''
        // debug  = true

        // wf =>  wc, wmds
        _.forEach(list_from_wf, f => {
          if(f.detect < 1) { return debug ? console.log('is safe', f) : '' }
          let wc = _.filter(list_from_wc, domain => {
            debug ? console.log('[+][domain] wf <-> wc ', f, domain, domain.indexOf(f) > -1  ? 'related attack' : '') : ''
            return domain && domain.indexOf(f) > -1
          })
          debug ? console.log('###############################################################') : ''
          let wmds = _.filter(this.WMDS, m => {
            debug ? console.log('[+][domain] wf <-> wmds ', f, m.fqdn, f.indexOf(m.fqdn) > -1 ? 'related attack' : '') : ''
            return f.indexOf(m.fqdn) > -1
          })

          if(wmds.length > 0 || wc.length > 0) {
            let index = _.findIndex(this.hot, x => f.indexOf(x.domain) > -1)

            if(index > -1) {
              if(this.hot[index].is_wc == false && wc.length > 0) {  this.hot[index].is_wc = true }
              if(this.hot[index].is_wmds == false && wmds.length > 0) {  this.hot[index].is_wmds = true }
            } else {
              this.hot.push(Object.assign({}, sample_data, { domain : f, is_wc :(wc.length > 0), is_wmds : (wmds.length > 0) }))
            }
            console.log('[V] update wf -> wc,wmds', this.hot[index < 0 ? this.hot.length -1 : index].domain)
          }
        })
        debug ? console.log('###############################################################') : ''
        debug ? console.log(this.hot) : ''
      } catch (e) { console.log('domain Correlation analysis failed', e) }

      // debug  = false


      // 아이피 관련 검사 // 이름도 검사함
      try {
        // webcastle =>  wsfinder, wf
        _.forEach(this.WC, c => {

          if(c.is_row && c.is_block > 0) { return console.log('[x] webcastle =>  wsfinder, wf') } // 탐지 되었는데 블럭 했음
          if(!c.ip_addr) { return console.log("can't check it, no have ip address") }
          let wsf = _.filter(this.WSF, s => {
            s.ip_addr = !s.ip_addr ? s.ip_addr_private : s.ip_addr
            debug ? console.log('[+][ip] wc <-> wsf', s.ip_addr, c.ip_addr, s.name, c.name, s.ip_addr == c.ip_addr ? 'related attack' : '') : ''
            return c.ip_addr && c.ip_addr && c.ip_addr == s.ip_addr && c.is_block
          })

          // 아이피로 매칭되는 서버가 있을 경우
          let wf = _.filter(this.WF, f => {
            if(f.detect_list.length < 1) { return console.log('[x] webcastle =>  wf') }
            debug ? console.log('[+][ip] wc <-> wf', c.ip_addr, f.ip_addr, c.name, f.name, c.ip_addr == f.ip_addr ? 'related attack' : '') : ''
            return c.ip_addr && c.ip_addr == f.ip_addr && (f.detect_list ? f.detect_list : []).length > 0
          })

          if(wsf.length > 0 || wf.length > 0) {
            let index = _.findIndex(this.hot, x => x.ip_addr == c.ip_addr)
            // console.log('wsf.length > 0 || wf.length > 0', wsf.length, wf.length)

            if(index > -1) {
              if(this.hot[index].is_wsf == false && wsf.length > 0) {  this.hot[index].is_wsf = true }
              if(this.hot[index].is_wf == false && wf.length > 0) {  this.hot[index].is_wf = true }
            } else {
              this.hot.push(Object.assign({}, sample_data, { ip_addr : c.ip_addr, is_wf :(wf.length > 0), is_wsf : (wsf.length > 0), is_wc : true, is_wmds : false }))
            }
            console.log('webcastle => [V] update by ip', this.hot[index < 0 ? this.hot.length -1 : index])
          }

          let wsf_name = _.filter(this.WSF, s => {
            debug ? console.log('[+][name] wc <-> wsf', s.ip_addr, c.ip_addr, s.name, c.name, s.name == c.name ? 'related attack' : '') : ''
            return c.name && c.name == s.name && (s.detect_list ? s.detect_list : []).length > 0
          })

          let wf_name = _.filter(this.WF, f => {
            // 아이피일 경우만 매칭됨
            debug ? console.log('[+][name] wc <-> wf', c.ip_addr, f.ip_addr, c.name, f.name, c.name == f.name ? 'related attack' : '') : ''
            return c.name && c.name == f.name && (f.detect_list ? f.detect_list : []).length > 0
          })

          if(wsf_name.length > 0 || wf_name.length > 0) {
            let index = _.findIndex(this.hot, x => x.ip_addr == c.ip_addr)

            if(index > -1) {
              if(this.hot[index].is_wsf == false && wsf.length > 0) {  this.hot[index].is_wsf = true }
              if(this.hot[index].is_wf == false && wf.length > 0) {  this.hot[index].is_wf = true }
            } else {
              console.log({ ip_addr : c.ip_addr, is_wf :(wf.length > 0), is_wsf : (wsf_name.length > 0), is_wc : true, is_wmds : false })
              this.hot.push(Object.assign({}, sample_data, { ip_addr : c.ip_addr, is_wf :(wf.length > 0), is_wsf : (wsf_name.length > 0), is_wc : true, is_wmds : false }))
            }
            console.log('webcastle => [V] update by name', this.hot[index < 0 ? this.hot.length -1 : index].ip_addr)
          }

        })

        // wsfinder =>  wc, wf by ip
        _.forEach(this.WSF, s => {
          if(!s.is_row) { return debug ? console.log('is safe', s.name) : '' }
          let wc = _.filter(this.WC, c => {
            debug ? console.log('[+][ip] wsf <-> wc ', c.ip_addr, s.ip_addr, c.name, s.name, c.ip_addr == s.ip_addr ? 'related attack' : '') : ''
            return ((c.ip_addr && c.ip_addr == s.ip_addr) || c.name == s.name) && (c.detect_list ? c.detect_list : []).length > 0
          })

          let wf = _.filter(this.WF, f => {
            debug ? console.log('[+][ip] wsf <-> wf ', f.ip_addr, s.ip_addr, f.name, s.name, f.ip_addr == f.ip_addr ? 'related attack' : '') : ''
            return f.ip_addr && f.ip_addr == s.ip_addr && (f.detect_list ? f.detect_list : []).length > 0
          })
          if(wc.length > 0 || wf.length > 0) {
            let index = _.findIndex(this.hot, x => x.ip_addr == s.ip_addr)

            if(index > -1) {
              if(this.hot[index].is_wc == false && wc.length > 0) {  this.hot[index].is_wc = true }
              if(this.hot[index].is_wf == false && wf.length > 0) {  this.hot[index].is_wf = true }
            } else {
              this.hot.push(Object.assign({}, sample_data, { ip_addr : s.ip_addr, is_wf :(wf.length > 0), is_wc : (wc.length > 0), is_wsf : true, is_wmds : false }))
            }
            console.log('wsfinder => [V] update by ip', this.hot[index < 0 ? this.hot.length -1 : index].ip_addr)
          }

          // update by name
          let wc_name = _.filter(this.WC, c => {
            debug ? console.log('[+][name] wsf <-> wc ', c.ip_addr, s.ip_addr, c.name, s.name, c.name == s.name ? 'related attack' : '') : ''
            return c.name && c.name == s.name && (c.detect_list ? c.detect_list : []).length > 0
          })

          let wf_name = _.filter(this.WF, f => {
            debug ? console.log('[+][name] wsf <-> wf ', f.ip_addr, s.ip_addr, f.name, s.name, f.name == f.name ? 'related attack' : '') : ''
            return f.name && f.name == s.name && (f.detect_list ? f.detect_list : []).length > 0
          })
          if(wc_name.length > 0 || wf_name.length > 0) {
            let index = _.findIndex(this.hot, x => x.ip_addr == s.ip_addr)

            if(index > -1) {
              if(this.hot[index].is_wc == false && wc.length > 0) {  this.hot[index].is_wc = true }
              if(this.hot[index].is_wf == false && wf.length > 0) {  this.hot[index].is_wf = true }
            } else {
              this.hot.push(Object.assign({}, sample_data, { ip_addr : s.ip_addr, is_wf :(wf.length > 0), is_wc : (wc.length > 0), is_wsf : true, is_wmds : false }))
            }
            console.log('wsfinder => [V] update by name', this.hot[index < 0 ? this.hot.length -1 : index].ip_addr)
          }
        })

        debug ? console.log('###############################################################') : ''
        debug ? console.log(this.hot) : ''

        // debug = true

        // wf =>  wc, wsfinder by ip
        _.forEach(this.WF, f => {
          if(f.detect < 1) { return debug ? console.log('wf is safe', f) : '' }
          let wc = _.filter(this.WC, c => {
            debug ? console.log('[+][ip] wf <-> wc ', f.ip_addr, c.ip_addr, f.name, c.name, f.ip_addr == c.ip_addr ? 'related attack' : '') : ''
            return c.ip_addr && c.ip_addr == f.ip_addr && (f.detect_list ? f.detect_list : []).length > 0
          })
          debug ? console.log('###############################################################') : ''
          let wsf = _.filter(this.WSF, s => {
            if(!s.is_row) { return debug ? console.log('is safe', s) : '' }
            debug ? console.log('[+][ip] wf <-> wsf ', f.ip_addr, s.ip_addr, f.name, s.name, f.ip_addr == s.ip_addr ? 'related attack' : '') : ''
            return s.ip_addr && s.ip_addr == f.ip_addr && (f.detect_list ? f.detect_list : []).length > 0
          })

          if(wsf.length > 0 || wc.length > 0) {
            let index = _.findIndex(this.hot, x => x.ip_addr == f.ip_addr)
            console.log('wsf.length > 0 || wc.length > 0', wsf.length, wc.length)

            if(index > -1) {
              if(this.hot[index].is_wc == false && wc.length > 0) {  this.hot[index].is_wc = true }
              if(this.hot[index].is_wsf == false && wsf.length > 0) {  this.hot[index].is_wsf = true }

            } else {
              this.hot.push(Object.assign({}, sample_data, { ip_addr : f.ip_addr, is_wc :(wc.length > 0), is_wsf : (wsf.length > 0), is_wf : true, is_wmds : false }))
            }
            console.log('wf => [V] update by ip', this.hot[index < 0 ? this.hot.length -1 : index].ip_addr)
          }

          // find by name
          wc = _.filter(this.WC, c => {
            debug ? console.log('[+][name] wf <-> wc ', f.ip_addr, c.ip_addr, f.name, c.name, f.name == c.name ? 'related attack' : '') : ''
            return c.name && c.name == f.name && (f.detect_list ? f.detect_list : []).length > 0
          })
          debug ? console.log('###############################################################') : ''
          wsf = _.filter(this.WSF, s => {
            if(!s.is_row) { return debug ? console.log('is safe', s) : '' }
            debug ? console.log('[+][name] wf <-> wsf ', f.name, s.name, f.name, s.name, f.name == s.name ? 'related attack' : '') : ''
            return s.name && s.name == f.name && (f.detect_list ? f.detect_list : []).length > 0
          })

          if(wsf.length > 0 || wc.length > 0) {
            let index = _.findIndex(this.hot, x => x.ip_addr == f.ip_addr)
            index == -1 ? _.findIndex(this.hot, x => x.ip_addr == f.ip_addr) : ''

            console.log('wsf.length > 0 || wc.length > 0', wsf.length, wc.length)

            if(index > -1) {
              if(this.hot[index].is_wc == false && wc.length > 0) {  this.hot[index].is_wc = true }
              if(this.hot[index].is_wsf == false && wsf.length > 0) {  this.hot[index].is_wsf = true }

            } else {
              this.hot.push(Object.assign({}, sample_data, { ip_addr : f.ip_addr, is_wc :(wc.length > 0), is_wsf : (wsf.length > 0), is_wf : true, is_wmds : false }))
            }
            console.log('wf => [V] update by name', this.hot[index < 0 ? this.hot.length -1 : index].name)
          }
        })


        debug ? console.log('###############################################################') : ''
        debug ? console.log(this.hot) : ''

        this.ping()
      } catch (e) { console.log('server Correlation analysis failed', e) }

    },
    stop_refresh() {
      clearTimeout(this.th)
      this.th = undefined;
    },
    res(m) {
      if(m.cmd != 'pong') { return }

      // console.info('pong', m.agent_id, m.target)
      switch (m.target.toLowerCase()) {
        case 'webcastle':
          this.wc_pong_list.push(m.agent_id)
          this.wc_pong_list = _.uniq(this.wc_pong_list);
          break
        case 'wsfinder':
          this.wsf_pong_list.push(m.agent_id)
          this.wsf_pong_list = _.uniq(this.wsf_pong_list);
          break
      }
    },
  },
  created() { this.load(); console.log('[vue] welcome', 'created'); },
  destroyed() {
    // signalr.off('webcastle', this.res)
    // signalr.off('wsfinder_response', this.res)
    if(this.ping_th) { clearTimeout(this.ping_th); this.ping_th = undefined; console.log("stop ping & status") }
    this.stop_refresh(); console.log('[vue] welcome', 'destroyed');
  },
  mounted() {
    // signalr.on('webcastle', this.res)
    // signalr.on('wsfinder_response', this.res)
    console.log('[vue] welcome', 'mounted');
  }
}
